import React from 'react';

const LoadingScreen: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center">
      <div className="text-center">
        {/* Animated Logo/Spinner */}
        <div className="relative w-16 h-16 mx-auto mb-6">
          {/* Outer spinning ring */}
          <div className="absolute inset-0 border-4 border-gray-700 border-t-blue-500 rounded-full animate-spin"></div>
          {/* Inner pulsing circle */}
          <div className="absolute inset-2 bg-blue-500/20 rounded-full animate-pulse"></div>
          {/* Center dot */}
          <div className="absolute inset-6 bg-blue-500 rounded-full"></div>
        </div>
        
        {/* Loading Text */}
        <h2 className="text-xl font-semibold text-white mb-2">Loading</h2>
        <p className="text-sm text-gray-400">Please wait...</p>
      </div>
    </div>
  );
};

export default LoadingScreen;
